import React from 'react';
import styled from 'styled-components';
import { FilterButton } from '../../../../../styles/theme/default/buttons';
import { BodyThree } from '../../../../../styles/theme/default/typography';

const Wrapper = styled.div`
  .filters-buttons-container {
    margin: 10px 0px 25px 0;
    display: flex;
    flex-wrap: wrap;
  }
`;

function FilterPattern({ patternIds, setPatternIds, patterns }) {
  const handleClick = patternId => {
    const isSelected = patternIds.some(id => id === parseInt(patternId));
    if (isSelected) {
      setPatternIds(patternIds.filter(id => id !== parseInt(patternId)));
    } else {
      setPatternIds([...patternIds, parseInt(patternId)]);
    }
  };

  if (patterns?.length === 0) {
    return null;
  }

  return (
    <Wrapper>
      <BodyThree>Pattern</BodyThree>
      <div className="filters-buttons-container">
        {patterns.map(pattern => {
          return (
            <FilterButton
              key={pattern.id}
              onClick={() => handleClick(pattern.id)}
              selected={patternIds.some(id => id === parseInt(pattern.id))}
            >
              {pattern.name}
            </FilterButton>
          );
        })}
      </div>
    </Wrapper>
  );
}

export default FilterPattern;
